/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListNoteConversation } from '../../models/api-response-list-note-conversation';

export interface ListNoteConversationByConvRef$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  convRef: string;
}

export function listNoteConversationByConvRef(http: HttpClient, rootUrl: string, params: ListNoteConversationByConvRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListNoteConversation>> {
  const rb = new RequestBuilder(rootUrl, listNoteConversationByConvRef.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('convRef', params.convRef, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListNoteConversation>;
    })
  );
}

listNoteConversationByConvRef.PATH = '/v1/api/ui/note-conversation/list/{convRef}';
